import { ok } from "@maker/result";
import { isAdapter } from "./adapter";
import type { FetcherMutationInputData } from "./fetcher";

function parseBodyMime<T>(data?: T) {
	if (data && isAdapter(data)) {
		return data.mime;
	}

	return null;
}

function parseBody(data?: FetcherMutationInputData) {
	if (data && isAdapter(data)) {
		return data.transform();
	}

	return ok(data);
}

export { parseBodyMime, parseBody };
